import OHIF from 'ohif-core';
import cornerstone from 'cornerstone-core';
import cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader';
import cornerstoneWebImageLoader from 'cornerstone-web-image-loader';
import dicomParser from 'dicom-parser';
import version from './version.js';

window.info = {
  version,
  homepage: `${process.env.PUBLIC_URL}`,
};

// For debugging
//if (process.env.node_env === 'development') {
window.cornerstone = cornerstone;
window.cornerstoneWADOImageLoader = cornerstoneWADOImageLoader;
window.cornerstoneWebImageLoader = cornerstoneWebImageLoader;
//}

cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;

cornerstoneWebImageLoader.external.cornerstone = cornerstone;
cornerstoneWebImageLoader.external.dicomParser = dicomParser;

getToken();
async function getToken() {
  const init = { method: 'GET' };

  const res = await fetch(`/ai-web/auth/getToken`, init);
  if (res.status === 200) {
    const result = await res.json();
    let token = result.data.access_token;
    window.localStorage.setItem('access_token', token);

    OHIF.user.getAccessToken = () => {
      // TODO: Get the Redux store from somewhere else
      return result.data.access_token;
      // const state = window.store.getState();
      // if (!state.oidc || !state.oidc.user) {
      //   return;
      // }

      // return state.oidc.user.access_token;
    };
  }
}

cornerstoneWADOImageLoader.configure({
  beforeSend: function(xhr) {
    const headers = OHIF.DICOMWeb.getAuthorizationHeader();

    if (headers.Authorization) {
      xhr.setRequestHeader('Authorization', headers.Authorization);
    }
  },
});

cornerstoneWebImageLoader.configure({
  beforeSend: function(xhr) {
    const headers = OHIF.DICOMWeb.getAuthorizationHeader();

    if (headers.Authorization) {
      xhr.setRequestHeader('Authorization', headers.Authorization);
    }
  },
});
